import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Ez egy Apple eszköz?
 * @param ua - UserAgent.
 */
export default function isApple (ua: string): boolean {
  return userAgentParser.isApple(ua)
}
